import { useMemo } from 'react';
import { renderSVG } from 'uqr';

/** v11 §2I (BOLT-029) — the lobby join QR. Encodes the SAME deep link the
 *  copy button shares (https://…/?code=XXXXXX): an iPhone Camera scan opens
 *  the native app via Universal Links when installed, else Safari's web join
 *  (Landing already parses ?code=) — graceful fallback is inherent. */
export function JoinQr({ url }: { url: string }) {
  const svg = useMemo(() => renderSVG(url, { border: 1 }), [url]);
  return (
    <div
      className="join-qr"
      data-testid="join-qr"
      data-url={url}
      aria-label={`QR code to join this game (${url})`}
      // uqr output is a self-generated static SVG of the url — no user HTML
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
